import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'subscriptionTiming',
  standalone: false,
})
export class SubscriptionTimingPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: unknown): string {
    return (
      this.translate.instant(`enums.subscriptionTiming.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
